import styled from 'styled-components';

export const IconsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 60px;
  gap: 10px;
  position: relative;
  overflow: visible !important;
`;
